import { IEvents } from '../../types/events';

export const EVENTS_BY_PAGE: IEvents = {
  start: 'where_to_begin',
  ad: 'publish_ad',
  show: 'show_apartment',
  'before-deal': 'prepare_for_deal',
  deal: 'deal',
  'after-deal': 'after_deal',
};
